import { getAssignedWashHubs } from 'api/sku';
import { useQuery, UseQueryOptions } from 'react-query';

import { Location } from 'types/washhub';

type Options = UseQueryOptions<Location[], unknown, Location[], string[]>;

export const useWashhubsForSKU = (packageId: string, options?: Options) => {
  const queryKey = ['fetch-assigned-sku-washhubs', packageId];
  const queryFn = () => getAssignedWashHubs(packageId);
  options = {
    ...options,
    enabled: !!packageId,
    refetchOnMount: 'always',
  };

  const query = useQuery(queryKey, queryFn, options);

  return query;
};
